import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { TPatchEconomy, TPatchEconomyResponse } from 'types/GlobalCustomer'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v2/customers/economy`

export async function updateEconomy(data: TPatchEconomy) {
  return Axios.patch<{ data: TPatchEconomyResponse }>(
    URL,
    { data },
    parseAuthenticationHeader()
  )
}
